import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './lib/styles/normalize';
import './lib/styles/global';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js